<div
    class="space-y-4 px-10 py-4 border-2 rounded-md"
    [ngClass]="error ? 'border-red-500' : 'border-gray-900/10'"
>
    <div class="text-lg font-semibold my-1">{{ title }}</div>
    @for (_ of filesArray; track $index; let i = $index) {
        <valben-file-input
            [key]="key"
            [itemObservable]="itemObservable"
            [update]="updateMethods[i]"
            fileType="application/pdf"
            [index]="singleIndex !== undefined ? singleIndex : i"
            [optional]="optional"
            [isKng]="isKng"
        >
        </valben-file-input>
    }
</div>
